import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { FC } from "react";

type TProps = {
  children?: React.ReactNode;
  title?: string;
  text?: string;
  openState: boolean;
  minWidth?: string;
  handleOnSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  handleOnReset?: () => void;
  handleOnClose: () => void;
};

const StdFormDialog: FC<TProps> = ({
  title,
  text,
  openState,
  minWidth,
  handleOnSubmit,
  handleOnReset,
  handleOnClose,
  children,
}) => {
  return (
    <Dialog
      open={openState}
      onClose={handleOnClose}
      PaperProps={{
        sx: { minWidth: minWidth ? minWidth : "50%" },
        component: "form",
        onSubmit: handleOnSubmit,
      }}
      disableRestoreFocus
    >
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>
        {text && <DialogContentText>{text}</DialogContentText>}
        {children}
      </DialogContent>
      <DialogActions>
        {handleOnReset && (
          <Button onClick={handleOnReset} variant="contained" color="warning">
            Reset
          </Button>
        )}
        <Button onClick={handleOnClose} variant="outlined">
          Cancel
        </Button>
        <Button type="submit" variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StdFormDialog;
